{
  "add": "Adicionar",
  "edit": "Editar",
  "delete": "Excluir",
  "save": "Salvar",
  "cancel": "Cancelar",
  "close": "Fechar",
  "confirm": "Confirmar",
  "done": "Concluído",
  "search": "Pesquisar...",
  "searchPlaceholder": "Pesquisar...",
  "filter": "Filtrar",
  "clear": "Limpar",
  "loading": "Carregando...",
  "error": "Erro",
  "success": "Sucesso",
  "warning": "Aviso",
  "info": "Informação",
  "yes": "Sim",
  "no": "Não",
  "ok": "OK",
  "back": "Voltar",
  "brandWordmark": "Homy",
  "backToHome": "Voltar ao HomyOS",
  "next": "Próximo",
  "previous": "Anterior",
  "submit": "Enviar",
  "saving": "Salvando...",
  "change": "Alterar",
  "inactive": "Inativo",
  "reset": "Redefinir",
  "select": "Selecionar",
  "selected": "Selecionado",
  "all": "Todos",
  "none": "Nenhum",
  "export": "Exportar",
  "general": "Geral",
  "or": "ou",
  "actions": {
    "title": "Ações",
    "save": "Salvar",
    "cancel": "Cancelar",
    "edit": "Editar",
    "delete": "Excluir",
    "close": "Fechar",
    "confirm": "Confirmar",
    "back": "Voltar",
    "next": "Avançar",
    "view": "Visualizar",
    "filter": "Filtrar",
    "reset": "Redefinir",
    "create": "Criar",
    "add": "Adicionar",
    "done": "Concluído",
    "submit": "Enviar"
  },
  "state": {
    "loading": "Carregando...",
    "saving": "Salvando...",
    "submitting": "Enviando...",
    "processing": "Processando..."
  },
  "saveFailed": "Erro ao salvar",
  "details": "Detalhes",
  "contextualHelp": {
    "trigger": "Ajuda e orientação",
    "openHelp": "Abrir ajuda",
    "closeHelp": "Fechar ajuda",
    "needMoreHelp": "Precisa de mais ajuda? Visite a Central de Ajuda"
  },
  "view": "Ver",
  "copy": "Copiar",
  "copied": "Link copiado!",
  "clickToCopy": "Clique para copiar",
  "copyFailed": "Não foi possível copiar o link",
  "share": "Compartilhar",
  "toast": {
    "copyErrorDetails": "Copiar detalhes do erro",
    "copied": "Copiado"
  },
  "download": "Baixar",
  "upload": "Enviar",
  "remove": "Remover",
  "create": "Criar",
  "update": "Atualizar",
  "name": "Nome",
  "email": "E-mail",
  "phone": "Telefone",
  "call": "Ligar",
  "address": "Endereço",
  "date": "Data",
  "pickDate": "Escolher data",
  "monthsShort": [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez"
  ],
  "time": "Hora",
  "status": {
    "title": "Status",
    "active": "Ativo",
    "inactive": "Inativo",
    "pending": "Pendente",
    "draft": "Rascunho",
    "archived": "Arquivado"
  },
  "type": "Tipo",
  "description": "Descrição",
  "required": "Obrigatório",
  "optional": "Opcional",
  "unassigned": "Não atribuído",
  "nav": {
    "dashboard": "Painel",
    "inbox": "Caixa de entrada",
    "listings": "Anúncios",
    "properties": "Propriedades",
    "visits": "Visitas",
    "bookings": "Reservas",
    "availability": "Disponibilidade",
    "eventTypes": "Tipos de evento",
    "applications": "Aplicações",
    "rentals": "Aluguéis",
    "pipelines": "Workflows",
    "workflows": "Workflows",
    "calendar": "Calendário",
    "maintenance": "Manutenção",
    "vendorCockpit": "Meu Painel",
    "maintenanceRequests": "Solicitações",
    "projects": "Projetos",
    "standingServices": "Serviços Recorrentes",
    "vendors": "Fornecedores",
    "marketplace": "Marketplace",
    "vendorStatements": "Faturas & Declarações",
    "support": "Suporte",
    "residentSupport": "Suporte",
    "orgSupport": "Fila de Atendimento",
    "helpCenter": "Central de Ajuda",
    "tasks": "Tarefas",
    "databases": "Bases de dados",
    "organizations": "Organização",
    "issues": "Pendências",
    "landingPage": "Página inicial",
    "trust": "Confiança e Verificação",
    "settings": "Configurações",
    "tenantLease": "Meu Aluguel",
    "tenantPayments": "Pagamentos",
    "toggleGroup": "Expandir ou recolher secção {{group}}",
    "openGroup": "Abrir menu {{group}}",
    "mainNavigation": "Navegação principal",
    "group": {
      "portfolioMarketing": "Carteira e marketing",
      "leasing": "Arrendamento",
      "schedule": "Agenda",
      "maintenance": "Manutenção",
      "workComms": "Trabalho e comunicações",
      "dataOrg": "Dados e organização"
    },
    "documents": "Documentos"
  },
  "organization": {
    "fallback": "Organização",
    "manage": "Gerenciar organização",
    "switch": "Trocar organização"
  },
  "viewAll": "Ver Tudo",
  "expandSidebar": "Expandir barra lateral",
  "collapseSidebar": "Recolher barra lateral",
  "collapse": "Recolher",
  "openMenu": "Abrir menu",
  "toggleTheme": "Alternar tema",
  "theme": {
    "toggle": "Alternar tema",
    "light": "Claro",
    "dark": "Escuro",
    "system": "Sistema"
  },
  "changeLanguage": "Alterar idioma",
  "morePages": "Mais páginas",
  "notifications": "Notificações",
  "platformConsole": "Console da Plataforma",
  "userFallback": "Usuário HomyOS",
  "roleFallback": "Gerente",
  "userMenu": {
    "openMenu": "Abrir menu da conta",
    "profile": "Perfil e preferências",
    "organization": "Organização",
    "security": "Segurança"
  },
  "logout": "Sair",
  "visits": {
    "title": "Visitas",
    "upcomingTitle": "Próximas visitas",
    "upcomingVisits": "Próximas visitas",
    "availability": "Disponibilidade",
    "empty": "Nenhuma visita agendada.",
    "failedToLoad": "Falha ao carregar visitas",
    "failedToUpdate": "Falha ao atualizar visita",
    "property": "Propriedade",
    "date": "Data",
    "status": "Status",
    "confirm": "Confirmar",
    "cancel": "Cancelar visita",
    "markNoShow": "Marcar ausência",
    "visitor": "Visitante",
    "configureAvailability": "Configurar",
    "sameHoursEveryDay": "Mesmos horários todos os dias",
    "whichDays": "Quais dias?",
    "whatHours": "Quais horários?",
    "to": "até",
    "howLongEachVisit": "Quanto tempo cada visita?",
    "slotsPerDay": "{{count}} vagas/dia",
    "slotsPerWeek": "{{count}} vagas/semana",
    "minVisits": "{{count}} min visitas",
    "noAvailability": "Sem disponibilidade configurada",
    "saveAvailability": "Salvar disponibilidade",
    "availabilitySaved": "Disponibilidade salva",
    "failedToSave": "Falha ao salvar disponibilidade",
    "minuteAbbrev": "min",
    "yourSchedule": "Seu Horário",
    "yourScheduleDescription": "Defina sua disponibilidade padrão para visitas",
    "perProperty": "Por Propriedade",
    "usingDefault": "Usando seu horário",
    "custom": "Personalizado",
    "applyToAll": "Aplicar a todas",
    "applyToAllConfirm": "Isto substituirá a disponibilidade de todas as propriedades pelo seu horário geral. Continuar?",
    "saveSchedule": "Salvar Horário",
    "scheduleSaved": "Horário salvo",
    "failedToSaveSchedule": "Falha ao salvar horário"
  },
  "errorBoundary": {
    "title": "Algo deu errado",
    "message": "Ocorreu um erro inesperado. Tente atualizar a página ou voltar ao início.",
    "refresh": "Atualizar página",
    "goHome": "Ir ao início"
  },
  "notFound": {
    "code": "Erro 404",
    "title": "Página não encontrada",
    "description": "A página que você está procurando não existe, foi removida ou foi movida para outro endereço.",
    "returnHome": "Voltar ao Painel"
  },
  "apiError": {
    "default": "Algo deu errado. Tente novamente.",
    "network": "Erro de conexão. Verifique sua rede e tente novamente."
  },
  "dataTable": {
    "rowsPerPage": "Por página",
    "showing": "Exibindo {{start}}–{{end}} de {{total}}",
    "sortAscending": "Ordenar ascendente",
    "sortDescending": "Ordenar descendente",
    "clearSort": "Limpar ordenação",
    "noResults": "Nenhum resultado."
  },
  "dateRangePicker": {
    "placeholder": "Selecionar intervalo de datas",
    "clear": "Limpar intervalo de datas",
    "presets": {
      "today": "Hoje",
      "last7": "Últimos 7 dias",
      "last30": "Últimos 30 dias",
      "mtd": "Mês até a data",
      "ytd": "Ano até a data"
    }
  },
  "list": {
    "filters": {
      "title": "Filtros",
      "active": "ativos",
      "clearAll": "Limpar filtros",
      "removeFilter": "Remover {{filter}}",
      "dateRange": "Intervalo de datas",
      "selectDateRange": "Filtrar por intervalo de datas"
    },
    "viewMode": {
      "label": "Modo de exibição",
      "table": "Tabela",
      "thumbnails": "Cartões",
      "grid": "Grade",
      "list": "Lista",
      "map": "Mapa",
      "kanban": "Quadro Kanban",
      "split": "Dividido"
    },
    "map": {
      "missingKeyTitle": "Mapa indisponível",
      "missingKeyDescription": "Configure VITE_GOOGLE_MAPS_API_KEY para habilitar a vista de mapa.",
      "loadFailedTitle": "Falha ao carregar o mapa",
      "loadFailedDescription": "Verifique sua conexão e tente novamente.",
      "noLocationsTitle": "Sem localizações",
      "noLocationsDescription": "Nenhum item tem coordenadas para exibir no mapa."
    }
  },
  "profile": "Perfil",
  "settings": "Configurações",
  "approvals": {
    "title": "Aprovações",
    "history": "Histórico de aprovações",
    "pending": "Aprovações pendentes",
    "noPending": "Nenhuma aprovação pendente encontrada.",
    "noHistory": "Nenhum registro de aprovação para este item.",
    "status": {
      "PENDING": "Pendente",
      "APPROVED": "Aprovado",
      "REJECTED": "Rejeitado",
      "CANCELLED": "Cancelado",
      "EXPIRED": "Expirado",
      "NEEDS_CLARIFICATION": "Requer esclarecimento"
    },
    "strategy": {
      "SINGLE": "Aprovador único",
      "ANY_OF": "Qualquer aprovador",
      "ALL_OF": "Todos os aprovadores",
      "SEQUENTIAL": "Sequencial"
    },
    "actions": {
      "approve": "Aprovar",
      "reject": "Rejeitar",
      "cancel": "Cancelar solicitação",
      "review": "Revisar",
      "submitting": "Enviando..."
    },
    "dialog": {
      "approveTitle": "Aprovar solicitação",
      "rejectTitle": "Rejeitar solicitação",
      "cancelTitle": "Cancelar solicitação de aprovação",
      "notesLabel": "Notas de revisão",
      "notesPlaceholder": "Adicione seus comentários ou justificativa (opcional)...",
      "reasonLabel": "Motivo do cancelamento",
      "reasonPlaceholder": "Explique por que esta solicitação está sendo cancelada...",
      "confirmApprove": "Confirmar aprovação",
      "confirmReject": "Confirmar rejeição",
      "confirmCancel": "Confirmar cancelamento"
    },
    "step": "Passo {{order}}",
    "request": "Solicitação",
    "requestedBy": "Solicitado por",
    "assignedTo": "Atribuído a",
    "resolvedBy": "Resolvido por",
    "requestedAt": "Solicitado em",
    "resolvedAt": "Resolvido em",
    "notes": "Notas",
    "entityType": "Entidade",
    "approvalType": "Tipo de aprovação"
  },
  "unsavedChanges": {
    "title": "Descartar alterações?",
    "description": "As alterações não salvas serão perdidas ao fechar o painel.",
    "keepEditing": "Continuar editando",
    "discard": "Descartar alterações"
  },
  "security": {
    "restricted": "Restrito",
    "masked": {
      "restrictedValue": "••••••",
      "restrictedTooltip": "Informações financeiras restritas"
    },
    "lockedMetricTooltip": "Esta métrica financeira é restrita pelas políticas da organização.",
    "unauthorized": {
      "title": "Acesso Restrito",
      "description": "Você não tem permissão para visualizar este conteúdo."
    }
  },
  "retry": "Tentar novamente",
  "brandLogoAlt": "HomyOS",
  "brandOs": "OS",
  "clearSearch": "Limpar busca",
  "more": "Mais",
  "progress": "Progresso",
  "created": "Criado",
  "statusLabel": "Status",
  "id": "ID",
  "filters": {
    "primaryStateFilters": "Filtros de status principais"
  },
  "impersonation": {
    "activeAria": "Impersonação diagnóstica ativa",
    "badgeTitle": "Impersonação diagnóstica",
    "badge": "Impersonado",
    "viewingAs": "Visualizando como",
    "in": "em",
    "readOnlyGuard": "Proteção de somente leitura ativa",
    "writeAllowed": "Gravação permitida",
    "ttl": "30m TTL",
    "operator": "Operador:",
    "endSession": "Encerrar sessão de diagnóstico",
    "exit": "Sair da impersonação"
  },
  "countryOptions": {
    "chile": "Chile (CLP / UF)",
    "argentina": "Argentina (ARS / USD)",
    "unitedStates": "Estados Unidos (USD)",
    "mexico": "México (MXN)",
    "brazil": "Brasil (BRL)",
    "colombia": "Colômbia (COP)",
    "spain": "Espanha (EUR)",
    "portugal": "Portugal (EUR)"
  },
  "landingPagePreview": "Pré-visualização da página",
  "landingPagePreviewError": "Não foi possível carregar a pré-visualização da página",
  "views": {
    "switcher": "Alterar exibição do aplicativo",
    "operations": "Operações",
    "resident": "Residente",
    "contractor": "Empreiteiro"
  },
  "fileDropzone": {
    "promptTitle": "Arraste e solte o arquivo aqui",
    "promptSubtitle": "Suporta PDF e imagens de até {{maxSizeMB}}MB",
    "browse": "Procurar arquivos",
    "uploading": "Enviando...",
    "ready": "Pronto",
    "failed": "Falhou",
    "preview": "Visualizar",
    "download": "Baixar",
    "remove": "Remover arquivo",
    "close": "Fechar",
    "empty": "Nenhum arquivo anexado",
    "previewUnavailable": "A visualização integrada não está disponível para este arquivo."
  },
  "notificationPopover": {
    "title": "Notificações",
    "markAllRead": "Marcar tudo como lido",
    "markRead": "Marcar como lido",
    "all": "Todas",
    "unread": "Não lidas",
    "emptyTitle": "Tudo em dia",
    "emptyUnread": "Nenhuma notificação não lida",
    "emptyAll": "Nenhuma notificação recente",
    "viewAll": "Ver tudo na Caixa de Entrada"
  },
  "auditTimeline": {
    "today": "Hoje",
    "yesterday": "Ontem",
    "activity": "Registro de auditoria",
    "eventSingular": "{{count}} evento",
    "eventPlural": "{{count}} eventos",
    "emptyTitle": "Nenhum evento de auditoria registrado",
    "emptySubtitle": "Os marcos de auditoria e eventos aparecerão aqui."
  },
  "editableCell": {
    "save": "Salvar (Enter)",
    "cancel": "Cancelar (Esc)",
    "invalidValue": "Valor inválido",
    "saveError": "Erro ao salvar",
    "selectPlaceholder": "Selecionar..."
  }
}
